import { BIndexThresholdType, QuestionStatus } from '@report/graphql';
import { dayjs } from '@shared/utils';
import { z } from 'zod';

export const itemAnalysisFilterFormSchema = z
  .object({
    startDate: z
      .date({ required_error: 'กรุณาเลือก Start Date' })
      .nullable()
      .refine((val) => val !== null, {
        message: 'กรุณาเลือก Start Date',
      }),
    endDate: z
      .date({ required_error: 'กรุณาเลือก End Date' })
      .nullable()
      .refine((val) => val !== null, {
        message: 'กรุณาเลือก End Date',
      }),
    examCourse: z.object(
      {
        value: z.string(),
        label: z.string(),
      },
      { message: 'กรุณาเลือกคลังข้อสอบ' },
    ),
    questionStatus: z
      .array(
        z.object({
          value: z.nativeEnum(QuestionStatus),
          label: z.string(),
        }),
        { message: 'กรุณาเลือกสถานะคำถาม' },
      )
      .min(1, { message: 'กรุณาเลือกสถานะคำถาม' }),
    minExaminees: z
      .number({ message: 'กรุณาระบุจำนวนผู้เข้าสอบขั้นต่ำ' })
      .refine((val) => val === 0 || val >= 300, {
        message: 'จำนวนผู้เข้าสอบต้องไม่น้อยกว่า 300 คน หรือกรอก 0 เพื่อเลือกทั้งหมด',
      }),
    bIndex: z.object({
      knowledgeGroup: z
        .object({
          knowledgeGroupSelection: z.nativeEnum(BIndexThresholdType),
          customThreshold: z.preprocess((val) => {
            if (val === '' || val === undefined || val === null) {
              return undefined;
            }

            return Number(val);
          }, z.number().optional()),
        })
        .refine(
          (val) => {
            if (val.knowledgeGroupSelection === BIndexThresholdType.UseExamResult) {
              return true;
            }

            if (val.knowledgeGroupSelection === BIndexThresholdType.CustomThreshold) {
              return val.customThreshold !== undefined;
            }

            return false;
          },
          {
            message: '',
            path: ['customThreshold'],
          },
        ),
      nonKnowledgeGroup: z
        .object({
          nonKnowledgeGroupSelection: z.nativeEnum(BIndexThresholdType),
          customThreshold: z.preprocess((val) => {
            if (val === '' || val === undefined || val === null) {
              return undefined;
            }

            return Number(val);
          }, z.number().optional()),
        })
        .refine(
          (val) => {
            if (val.nonKnowledgeGroupSelection === BIndexThresholdType.UseExamResult) {
              return true;
            }

            if (val.nonKnowledgeGroupSelection === BIndexThresholdType.CustomThreshold) {
              return val.customThreshold !== undefined;
            }

            return false;
          },
          {
            message: '',
            path: ['customThreshold'],
          },
        ),
    }),
  })
  .refine((data) => dayjs(data.endDate).isAfter(data.startDate), {
    message: 'End Date ต้องมากกว่า Start Date',
    path: ['endDate'],
  });

export type ItemAnalysisFilterFormInput = z.infer<typeof itemAnalysisFilterFormSchema>;
